import $axios from "@/service/httpServer";
// 获取组织列表
/**
 * @param {object} p
 * @param {string,number} p.folder_id 
*/
export const getFolderList = p => $axios.post('/Web/Backend/ResourceFolder/list', p);
// 无参数
export const getFolderListAll = () => $axios.post('/Web/Backend/ResourceFolder/listAll');

export const getFileList = p => $axios.post('/Web/Backend/ResourceFile/page', p); /** @param {object} p; @param {string,number} p.folder_id*/ 

export const addFolder = p => $axios.post('/Web/Backend/ResourceFolder/add', p);

export const delFolder = p => $axios.post('/Web/Backend/ResourceFolder/delete', p);

export const delFile = p => $axios.post('/Web/Backend/ResourceFile/delete',p);

export const renameFolder = p => $axios.post('/Web/Backend/ResourceFolder/rename', p);

export const moveFolder = p => $axios.post('/Web/Backend/ResourceFolder/move', p);

export const moveFile = p => $axios.post('/Web/Backend/ResourceFile/move', p);

export const getUploadToken = p => $axios.post('/Web/Backend/ResourceFile/genQnToken',p);


